<panel width="600">
  <div class="panel-section">
    <h1>{{ 'taskflowlist.open' | translate }}</h1>
    <ng-container *ngTemplateOutlet="taskflowList; context:{ taskflows: openTaskflows, closed: false }" />
    @if (isLoading) {
      <skeletons [defaultSkeletons]="2" />
    }
  </div>
  <div class="panel-section">
    <h1>{{ 'taskflowlist.closed' | translate }}</h1>
    <ng-container *ngTemplateOutlet="taskflowList; context:{ taskflows: closedTaskflows, closed: true }" />
    @if (isLoading) {
      <skeletons [defaultSkeletons]="2" />
    }
  </div>
</panel>

<ng-template #taskflowList let-taskflows="taskflows" let-closed="closed" let-parentList="parentList">
  <list-view #listView [parentList]="parentList">
    <header>{{ 'taskflowlist.title' | translate }}</header>
    <header>{{ 'taskflowlist.owner' | translate }}</header>
    <header [defaultSort]="!closed ? 'ascending' : undefined">{{ 'taskflowlist.created-date' | translate }}</header>
    <header [defaultSort]="closed ? 'descending' : undefined">{{ (closed ? 'taskflowlist.closed-date' : 'taskflowlist.deadline-date') | translate }}</header>
    <row *listData="let taskflow from taskflows"
      [statusIcon]="taskflow.status == completedStatus ? 'clipboard-check' : 'clipboard-list'"
      [statusColor]="taskflow.status == completedStatus ? 'color-green-50' : 'color-yellow-50'"
      [highlighted]="taskflow.id === selectedTaskflowId"
      (action)="selectTaskflow(taskflow.id)"
      [showCollapseIcon]="true"
      [collapsed]="taskflow.subTaskflows.length > 0 ? false : undefined"
      (collapsedChange)="taskflow.collapsed = $event">

      <column>{{ taskflow.title }}</column>
      <column>{{ taskflow.owner | user: 'initials' }}</column>
      <column [sortValue]="taskflow.created">{{ taskflow.created | customDate: 'shortDate' }}</column>
      @if (!closed) {
        <column [sortValue]="taskflow.deadline">{{ taskflow.deadline | customDate: 'shortDate' }}</column>
      }
      @if (closed) {
        <column [sortValue]="taskflow.completed">{{ taskflow.completed | customDate: 'shortDate' }}</column>
      }

      @if (taskflow.subTaskflows && !taskflow.collapsed) {
        <ng-container *ngTemplateOutlet="taskflowList; context:{ taskflows: taskflow.subTaskflows, closed: closed, parentList: listView }" />
      }

    </row>
  </list-view>
</ng-template>
